<template>
  <div class="classContainer">
    <van-nav-bar
      title="课程表"
      left-text=""
      left-arrow
      :border="false"
      @click-left="onClickLeft"
    />
    <div class="classSchedule">
<!--      <div class="classTop  mb10" @click="show = true">-->
<!--        <p class="classTitle">{{ majorName }}<img class="classSelect" src="@/assets/images/sxjt.png"/></p>-->
<!--        <p class="classTime">{{ semesterName }}&nbsp;&nbsp;|&nbsp;&nbsp;{{ gradeName }}</p>-->
<!--      </div>-->
      <div class="classTable mb10">
        <div class="timeCon">
          <p :class="[item.name == weekName?'active':'','time']" v-for="item in weekday" @click="formatList(item.name)">
            <span class="span week">{{ item.week }}</span>
            <span class="span">{{ item.date }}</span>
          </p>
        </div>
        <div class="changeWeek" @click="showCalendar = true">
          <img src="@/assets/images/leftArrow.png" alt="" class="leftArrow">
          <span class="weekNum">{{ yearWeekDateStr }}{{mouthStr?mouthStr:''}}</span>
          <img src="@/assets/images/leftArrow.png" alt="" class="leftArrow rightArrow">
        </div>
      </div>
      <div class="sectionCon">
        <div class="section mb10" v-for="item in formatDateList">
          <p class="title">{{ item.sectionNumStr }}</p>
          <div class="sectionItem" v-for="val in item.contentList" @click="goPrecess(val.planDetailId)">
            <p class="dsc">课程：{{val.content}}</p>
            <p class="teach">教师：{{val.teacherName}}</p>
          </div>
        </div>
      </div>
    </div>
<!--    <van-popup v-model="show" position="bottom" round class="popupBox">-->
<!--      <div class="conPopup">-->
<!--        <p class="title">筛选</p>-->
<!--        <div class="filtrateCon">-->
<!--          <div class="filtrate">-->
<!--            <p class="top">-->
<!--              <span class="line"></span>-->
<!--              <span class="text">专业</span>-->
<!--            </p>-->
<!--            <div class="itemCon">-->
<!--              <p :class="[item.majorId == queryForm.majorId?'active':'','item' ]" @click="queryForm.majorId = item.majorId" v-for="item in classMajorData">{{ item.majorName }}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="filtrate">-->
<!--            <p class="top">-->
<!--              <span class="line"></span>-->
<!--              <span class="text">学期</span>-->
<!--            </p>-->
<!--            <div class="itemCon">-->
<!--              <p :class="[item.semesterId == queryForm.semesterId?'active':'','item' ]" @click="queryForm.semesterId = item.semesterId" v-for="item in semesterData">{{ item.semesterName }}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="filtrate">-->
<!--            <p class="top">-->
<!--              <span class="line"></span>-->
<!--              <span class="text">年级</span>-->
<!--            </p>-->
<!--            <div class="itemCon">-->
<!--              <p :class="[item.gradeId == queryForm.gradeId?'active':'','item']" @click="queryForm.gradeId = item.gradeId" v-for="item in classGradeData">{{ item.gradeName }}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="btnBox">-->
<!--          <div class="resetBtn" @click="resetForm">重置</div>-->
<!--          <div class="completeBtn" @click="confirmSearch">确定</div>-->
<!--        </div>-->
<!--      </div>-->

<!--    </van-popup>-->
    <van-calendar color="#3776FF" :min-date="minDate" :max-date="maxDate" :default-date="defaultDate" :show-toolbar="false" v-model="showCalendar" @confirm="onConfirm" />
  </div>
</template>

<script>
import { setToken } from '@/utils/auth'
import {teachingSemesterList, teachingMajorList, teachingGradeList, getH5SchoolTimetable} from '@/api/classSchedule'
import wx from 'weixin-js-sdk'
export default {
  name: "index",
  data() {
    return {
      semesterName:'',
      majorName:'',
      gradeName:'',
      yearWeekDateStr:'',
      mouthStr:'',
      queryForm:{
        semesterId:'',
        majorId:'',
        gradeId:'',
        weekday:'',
        queryType:''
      },
      show:false,
      showCalendar: false,
      minDate:  new Date(2020, 0, 1),
      maxDate: undefined,
      defaultDate:undefined,
      startTime: '',
      endTime: '',
      today: '',
      token:'',
      semesterData:[],
      classMajorData:[],
      classGradeData:[],
      weekday: [{week:'周一',date:'',name:'mondayList'},{week:'周二',date:'',name:'tuesdayList'},{week:'周三',date:'',name:'wednesdayList'},{week:'周四',date:'',name:'thursdayList'},{week:'周五',date:'',name:'fridayList'},{week:'周六',date:'',name:'saturdayList'},{week:'周日',date:'',name:'sundayList'}],
      timeTableList:null,
      formatDateList:[],
      weekName:'mondayList'
    }
  },
  mounted() {
    // window.getU3dParams = this.getU3dParams;
    this.queryForm.queryType = this.$route.query.queryType?this.$route.query.queryType:'0'

    window.addEventListener("tokenEvent",( event )=>{
      this.initData();
    }, false);

    this.initData();
    let nowDat = new Date();
    let dateY = nowDat.getFullYear();
    let dateM = nowDat.getMonth();
    let dateD = nowDat.getDate();
    //日历可选范围为一年，dateY + 1
    this.maxDate = new Date(dateY + 2, dateM, dateD);
  },
  methods: {
    async initData() {
      if(this.$route.query.weekday){
        // this.queryForm.semesterId = this.$route.query.semesterId
        // this.queryForm.majorId = this.$route.query.majorId
        // this.queryForm.gradeId = this.$route.query.gradeId
        this.queryForm.weekday = this.$route.query.weekday
        // this.semesterName = this.$route.query.semesterName
        // this.majorName = this.$route.query.majorName
        // this.gradeName = this.$route.query.gradeName
        this.yearWeekDateStr = this.$route.query.yearWeekDateStr
        this.weekName = this.$route.query.weekName
      }else{
        this.queryForm.weekday = this.getFormattedDate();
      }
      let week = this.getYearWeek(this.queryForm.weekday.split('-')[0],this.queryForm.weekday.split('-')[1],this.queryForm.weekday.split('-')[2])
      this.yearWeekDateStr = this.queryForm.weekday.split('-')[0]+'第'+week+'周'
      // this.mouthStr = this.startTime.split('-')[1]+'.'+this.startTime.split('-')[2]
      this.defaultDate = new Date(Number(this.queryForm.weekday.split('-')[0]), Number(this.queryForm.weekday.split('-')[1])-1, Number(this.queryForm.weekday.split('-')[2]))

      // await this.querySemesterList()
      // await this.queryMajorList()
      // await this.queryGradeList()

      this.getDataClass()
    },
    judgeClient() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
      if (isAndroid) {
        return "Android";
      } else if (isIOS) {
        return "IOS";
      } else {
        return "PC";
      }
    },
    getFormattedDate(){
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate
    },
    getDateToday(){
      this.today = this.getFormattedDate();
      if (new Date(this.endTime) > new Date(this.today) && new Date(this.startTime) < new Date(this.today)) {
        return true
      } else {
        return false
      }
    },
    //查询学期列表
    async querySemesterList() {
      let res = await teachingSemesterList()
      this.semesterData = res.data;
      let objSemester = null
      if(!this.$route.query.semesterId){
        objSemester = this.semesterData[0]
        }else{
        objSemester = this.semesterData.filter(item=>item.semesterId == this.queryForm.semesterId)[0]
      }
      if(this.semesterData.length>0){
        this.queryForm.semesterId = this.semesterData.length > 0?objSemester.semesterId:'';
        this.semesterName = this.semesterData.length > 0?objSemester.semesterName:'';
        this.startTime = objSemester.startDate
        this.endTime = objSemester.endDate
        //日历范围选择
        this.minDate = new Date(Number(this.startTime.split('-')[0]), Number(this.startTime.split('-')[1])-1, Number(this.startTime.split('-')[2]))
        this.maxDate = new Date(Number(this.endTime.split('-')[0]), Number(this.endTime.split('-')[1])-1, Number(this.endTime.split('-')[2]))
      }
      if (this.getDateToday()) {
        this.queryForm.weekday = this.getFormattedDate();
      } else {
        this.queryForm.weekday = objSemester.startDate
      }
      let week = this.getYearWeek(this.queryForm.weekday.split('-')[0],this.queryForm.weekday.split('-')[1],this.queryForm.weekday.split('-')[2])
      this.yearWeekDateStr = this.queryForm.weekday.split('-')[0]+'第'+week+'周'
      this.mouthStr = this.startTime.split('-')[1]+'.'+this.startTime.split('-')[2]
      this.defaultDate = new Date(Number(this.queryForm.weekday.split('-')[0]), Number(this.queryForm.weekday.split('-')[1])-1, Number(this.queryForm.weekday.split('-')[2]))

    },
    onClickLeft() {
      if( localStorage.getItem("source")){
        wx.miniProgram.postMessage({
          data: {
            action:"back",
            title: 'ceshi'
          }
        })
        wx.miniProgram.navigateBack()

      }else{
        if (this.judgeClient() == "Android") {
          this.closeAndroid();
        } else {
          this.closeIos();
        }
      }


    },
    closeAndroid() {
      this.$bridge.callmethod(
        "WebAction.closeWeb",
        { ceshi: "ceshi" },
        (res) => {
        }
      );
    },
    closeIos() {
      try {
        //使用此方法,会报错,因此使用try-catch
        webkit.messageHandlers.closeWeb.postMessage("js调用ios");
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }
    },
    //重置
    // resetForm(){
    //   this.queryForm.semesterId = this.semesterData.length > 0?this.semesterData[0].semesterId:'';
    //   this.semesterName = this.semesterData.length > 0?this.semesterData[0].semesterName:'';
    //   this.queryForm.majorId = this.classMajorData.length > 0?this.classMajorData[0].majorId:'';
    //   this.majorName = this.classMajorData.length > 0?this.classMajorData[0].majorName:'';
    //   this.queryForm.gradeId = this.classGradeData.length > 0?this.classGradeData[0].gradeId:'';
    //   this.gradeName = this.classGradeData.length > 0?this.classGradeData[0].gradeName:'';
    //   this.show = false
    //   this.getDataClass();
    // },
    // //确定搜索
    // confirmSearch(){
    //   this.semesterName = this.queryForm.semesterId?this.semesterData.filter(item=>item.semesterId == this.queryForm.semesterId)[0].semesterName:'';
    //   this.majorName = this.queryForm.majorId?this.classMajorData.filter(item=>item.majorId == this.queryForm.majorId)[0].majorName:'';
    //   this.gradeName = this.queryForm.gradeId?this.classGradeData.filter(item=>item.gradeId == this.queryForm.gradeId)[0].gradeName:'';
    //   this.show = false;
    //  let objSemester = this.semesterData.filter(item=>item.semesterId == this.queryForm.semesterId)[0]
    //     this.queryForm.semesterId = this.semesterData.length > 0?objSemester.semesterId:'';
    //     this.semesterName = this.semesterData.length > 0?objSemester.semesterName:'';
    //     this.startTime = objSemester.startDate
    //     this.endTime = objSemester.endDate
    //     //日历范围选择
    //     this.minDate = new Date(Number(this.startTime.split('-')[0]), Number(this.startTime.split('-')[1])-1, Number(this.startTime.split('-')[2]))
    //     this.maxDate = new Date(Number(this.endTime.split('-')[0]), Number(this.endTime.split('-')[1])-1, Number(this.endTime.split('-')[2]))
    //
    //   if (this.getDateToday()) {
    //     this.queryForm.weekday = this.getFormattedDate();
    //   } else {
    //     this.queryForm.weekday = objSemester.startDate
    //   }
    //   let week = this.getYearWeek(this.queryForm.weekday.split('-')[0],this.queryForm.weekday.split('-')[1],this.queryForm.weekday.split('-')[2])
    //   this.yearWeekDateStr = this.queryForm.weekday.split('-')[0]+'第'+week+'周'
    //   this.mouthStr = this.startTime.split('-')[1]+'.'+this.startTime.split('-')[2]
    //   this.defaultDate = new Date(Number(this.queryForm.weekday.split('-')[0]), Number(this.queryForm.weekday.split('-')[1])-1, Number(this.queryForm.weekday.split('-')[2]))
    //
    //
    //   this.getDataClass();
    // },
    //跳转课表进度表
    goPrecess(planDetailId){
      this.$router.push('/teachProcess?planDetailId='+planDetailId
        +'&weekday='+this.queryForm.weekday
        +'&yearWeekDateStr='+this.yearWeekDateStr
        +'&weekName='+this.weekName+'&queryType='+this.queryForm.queryType
      )
    },
    //选择日期
    onConfirm(date){
      let getMonth='',getDay='';
      if (date.getMonth()+1<10){
        getMonth = '0'+(date.getMonth()+1)
      }else{
        getMonth = (date.getMonth()+1)
      }
      if (date.getDate()<10){
        getDay = '0'+(date.getDate())
      }else{
        getDay = date.getDate()
      }
      this.queryForm.weekday = date.getFullYear()+'-'+getMonth+'-'+getDay
      let week = this.getYearWeek(date.getFullYear(),getMonth,getDay)
      this.yearWeekDateStr = date.getFullYear()+'第'+week+'周'
      this.showCalendar = false;
      this.getDataClass()
    },
    //根据日期获取年周
    getYearWeek(a, b, c){
      var date1 = new Date(a, parseInt(b) - 1, c),  //当前日期
        date2 = new Date(a, 0, 1),  //当年第一天
        // d是当前日期是今年第多少天
        d = Math.round((date1.valueOf() - date2.valueOf()) / 86400000);
      // d + 当前年的第一天的周差距的和在除以7就是本年第几周
      return Math.ceil((d + (date2.getDay() + 1 - 1)) / 7);
    },
    //获取日历数据
    async getDataClass() {
      let res = await getH5SchoolTimetable(this.queryForm)
      let weeddayList = res.data.weeddayList;
      this.mouthStr = weeddayList[0].split('-')[1]+'.'+weeddayList[0].split('-')[2]+'-'+weeddayList[weeddayList.length-1].split('-')[1]+'.'+weeddayList[weeddayList.length-1].split('-')[2]
      for(var i=0;i<this.weekday.length;i++){
        this.weekday[i].date = weeddayList[i].split('-')[2]
      }
      this.timeTableList = res.data;
      this.formatList(this.weekName)
    },
    formatList(type){
      this.weekName = type
      this.formatDateList = this.timeTableList[type]
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .van-nav-bar .van-icon{
  color: #2F2F46
}
.mb10{
  margin-bottom: 10px;
}
.classContainer{
  .classSchedule{
    height: calc(100vh - 46px);
    background: #f5f5f5;
    padding: 8px 12px;
    .classTop{
      padding: 14px 17px;
      background: #FFFFFF;
      border-radius: 10px;
      .classTitle{
        font-weight: 600;
        font-size: 16px;
        color: #2F2F46;
        .classSelect{
          width: 6px;
          height: 11px;
          margin-left: 7px;
        }
      }
      .classTime{
        margin-top: 4px;
        font-weight: 400;
        font-size: 14px;
        color: #8F91A1;
      }
    }
    .classTable{
      padding: 10px 12px 12px 17px;
      background: #FFFFFF;
      border-radius: 10px;
      .timeCon{
        display: flex;
        justify-content: space-between;
        font-size: 11px;
        color: #2F2F46;
        .time{
          width: 36px;
          height: 50px;
          padding: 8px 0;
          text-align: center;
          .span{
            display: block;
          }
          .week{
            margin-bottom: 6px;
          }
        }
        .active{
          color: #FFFFFF;
          background: #3776FF;
          border-radius: 8px;
        }
      }
      .changeWeek{
        margin-top: 12px;
        display: flex;
        justify-content: center;
        .leftArrow{
          width: 14px;
        }
        .weekNum{
          font-weight: 400;
          font-size: 11px;
          color: #8F91A1;
          margin: 0 10px;
          letter-spacing:1px
        }
        .rightArrow{
          transform: rotate(180deg);
        }
      }
    }
    .sectionCon{
      height: calc(100% - 200px);
      overflow-y: auto;
      .section{
        padding: 14px 17px 9px 17px;
        background: #FFFFFF;
        border-radius: 10px;
        .title{
          font-weight: 600;
          font-size: 14px;
          color: #2F2F46;
        }
        .sectionItem{
          border-bottom: 1px solid #EBEBEB;
          padding-bottom: 5px;
          word-break: break-all;
        }
        .sectionItem:last-child{
          border-bottom: none;
        }
        .dsc,.teach{
          margin-top: 5px;
          font-weight: 400;
          font-size: 14px;
          color: #7A7C8B;
        }
      }
      .section:last-child{
        margin-bottom: 0;
      }
    }

  }
}
.conPopup{
  padding: 16px;
  .title{
    text-align: center;
    font-weight: 600;
    font-size: 16px;
    color: #2F2F46;
  }
  .filtrateCon{
    margin-top: 10px;
    max-height: 500px;
    overflow-y: auto;
    .filtrate{
      margin-bottom: 18px;
      .top{
        display: flex;
        align-items: center;
        .line{
          display: inline-block;
          width: 3px;
          height: 16px;
          background: #378CFF;
          border-radius: 1px;
        }
        .text{
          margin-left: 6px;
          font-weight: 600;
          font-size: 16px;
          color: #2F2F46;
        }
      }
      .itemCon{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .item{
          margin-top: 14px;
          width: calc(50% - 16px);
          height: 40px;
          text-align: center;
          line-height: 40px;
          background: #FFFFFF;
          border-radius: 8px;
          border: 1px solid #EEEEEE;
          font-weight: 400;
          font-size: 15px;
          color: #2F2F46;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .active{
          background: #EBF1FF;
          color: #3776FF;
          border:none;
        }
        .item4{
          width: calc(25% - 16px);
          margin-right: 16px;
        }
      }
      .itemCon4{
        justify-content: start;
      }
    }
  }
  .btnBox {
    display: flex;
    margin-top: 59px;
    width: 100%;
    height: 44px;
    .resetBtn {
      width: 50%;
      height: 44px;
      background: #EBF1FF;
      border-radius: 22px 0px 0px 22px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #3776FF;
      line-height: 44px;
      text-align: center;
      font-style: normal;
    }
    .completeBtn {
      width: 50%;
      height: 44px;
      background: #3776FF;
      border-radius: 0px 22px 22px 0px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      line-height: 44px;
      text-align: center;
      font-style: normal;
    }
  }
}
</style>
